import React from 'react';
import ReactDOMServer from 'react-dom/server';
import createReactClass from 'create-react-class';
import FormControllerProxy from 'lib/form/controller_proxy';
import Checkbox from 'views/ui/form_elements/checkbox';
import { t } from 'services/translation';
import _ from 'underscore';
import { Theme } from 'ui_system/theme';

export default createReactClass({
  displayName: 'PrivacyPolicy',
  mixins: [FormControllerProxy],

  _anyroadPrivacyPolicy() {
    return (
      <Checkbox {...this._formProps('anyroad_privacy_policy')}>
        {t('CONFIRM_HAVE_READ')}
        {this._privacyPolicyLink(
          'https://www.anyroad.com/end-user-terms',
          t('ANYROAD_TERMS')
        )}{' '}
        {t('AND_AGREE_TO_THE_USAGE_OF_YOUR_DATA_ACCORDING_TO')}
        {this._privacyPolicyLink(
          'https://www.anyroad.com/privacy',
          t('ANYROAD_PRIVACY')
        )}
      </Checkbox>
    );
  },

  _customizeErrorText() {
    const guidePrivacyPolicyErrors = this._formProps(
      'privacy_policy_accepted'
    ).errors;
    const anyroadPrivacyPolicyErrors = this._formProps(
      'anyroad_privacy_policy'
    ).errors;
    if (guidePrivacyPolicyErrors && guidePrivacyPolicyErrors[0]) {
      this._formProps('privacy_policy_accepted').errors[0] =
        'Please accept our Privacy Policy';
    }
    if (anyroadPrivacyPolicyErrors && anyroadPrivacyPolicyErrors[0]) {
      this._formProps('anyroad_privacy_policy').errors[0] =
        "Please accept AnyRoad's Terms of Service and Privacy Policy.";
    }
  },

  _guidePrivacyPolicy(privacyPolicyLink, privacyPolicyLinkText) {
    const privacyPoliciesAndLinks = [
      privacyPolicyLink.split('\n'),
      privacyPolicyLinkText.split('\n'),
    ];
    const link = this._privacyPolicyLink(
      privacyPoliciesAndLinks[0][0],
      privacyPoliciesAndLinks[1][0]
    );
    let privacyHtml = t(
      'PLEASE_CONFIRM_THAT_YOU_HAVE_READ_AND_ACCEPT_OUR',
      '',
      {
        link,
      }
    );
    if (privacyPoliciesAndLinks[0].length > 1) {
      privacyHtml += this._privacyPolicyLink(
        privacyPoliciesAndLinks[0][1],
        privacyPoliciesAndLinks[1][1],
        t('AND')
      );
    }
    return (
      <Checkbox
        {...this._formProps('privacy_policy_accepted')}
        dataTestProp="privacy-policy-checkbox"
      >
        <div
          dangerouslySetInnerHTML={{ __html: privacyHtml } /* // nosemgrep */}
        />
      </Checkbox>
    );
  },

  _privacyPolicyLink(linkDestination, linkText, extraText = '') {
    return ReactDOMServer.renderToStaticMarkup(
      <span>
        {' '}
        {extraText}{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`${linkDestination}`}
          className="brand-color"
          style={{ color: Theme.colors.linksDesignElementsBaseColor }}
          data-testid="privacy-policy-link"
        >
          {` ${linkText}`}
        </a>
      </span>
    );
  },

  render() {
    this._customizeErrorText();
    const {
      privacy_policy_link,
      privacy_policy_link_text,
      anyroadPrivacyPolicy,
    } = this.props;
    const styling = { textAlign: 'left' };
    const extraMobileClass = window.mobileDetect.mobile()
      ? ' mobile-privacy-policy'
      : '';

    return (
      <div
        className={`CheckoutWaiverContainer PrivacyPolicyContainer ${extraMobileClass}`}
        style={styling}
      >
        {anyroadPrivacyPolicy
          ? this._anyroadPrivacyPolicy()
          : this._guidePrivacyPolicy(
              privacy_policy_link,
              privacy_policy_link_text
            )}
      </div>
    );
  },
});
